export default __webpack_public_path__ + "static/media/MXSOUL.19f4ade8.png";